export const TEMPERATURE_CORRECTION_COEF_LIMITS_MIN = 0;
export const TEMPERATURE_CORRECTION_COEF_LIMITS_MAX = 4;
export const TEMPERATURE_CORRECTION_COEF_LIMITS_STEP = 0.2;
